import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import CapabilitiesPage from "./pages/CapabilitiesPage";
import ProductsServicesPage from "./pages/ProductsServicesPage";
import CategoryPage from "./pages/CategoryPage";
import ItemDetailPage from "./pages/ItemDetailPage";
import CertificationPage from "./pages/CertificationPage";
import ClientsPage from "./pages/ClientsPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/tentang" element={<AboutPage />} />
          <Route path="/kapabilitas" element={<CapabilitiesPage />} />
          
          {/* 3-Level Product Structure */}
          <Route path="/produk-layanan" element={<ProductsServicesPage />} />
          <Route path="/produk-layanan/:categoryId" element={<CategoryPage />} />
          <Route path="/produk-layanan/:categoryId/:itemId" element={<ItemDetailPage />} />
          
          {/* Redirects for old routes */}
          <Route path="/produk" element={<Navigate to="/produk-layanan" replace />} />
          <Route path="/produk/:productId" element={<Navigate to="/produk-layanan" replace />} />
          <Route path="/mesin" element={<Navigate to="/produk-layanan" replace />} />
          <Route path="/mesin/:machineId" element={<Navigate to="/produk-layanan" replace />} />
          
          <Route path="/sertifikasi" element={<CertificationPage />} />
          <Route path="/klien" element={<ClientsPage />} />
          <Route path="/kontak" element={<ContactPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </div>
  );
}

export default App;
